import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import constants from "../period-calculator-constants/OC_Constants";
import DatePicker from "react-datepicker";
import addDays from "date-fns/addDays";
import Customdatepicker from "./Customdatepicker";
import { isMobile } from "react-device-detect";
import "react-datepicker/dist/react-datepicker.css";
import "./PeriodLayout.css";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { registerLocale } from  "react-datepicker";
import enIN from 'date-fns/locale/en-IN';
registerLocale('enIN', enIN)

const currentdate = new Date();
const defaultview = true;

class LastPeriod extends React.PureComponent {
  // Setting component default state here
  state = {
    cycleLengthValue: constants.DEFAULT_CYCLE_LENGTH, //Default value
    dayValue: new Date().getDate(), // used for default selected value in dropdown
    monthValue: new Date().getMonth(), // used for default selected value in dropdown
    yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
    periodDuration: constants.DEFAULT_PERIOD_DURATION,
    isPeriodChange: false,
    isCycleChange: false,
    showPlus: false,
    showRangeSlider: false,
    dplabel: this.props.componentData.dateSelectionLabel.value,
    startDate: null,
    // monthtoshown: isMobile ? 1 : 2,
    currentDate: new Date(),
    lastPeriodDateLogo: this.props.parentCompData.datePickerLogo.value,
    copen: defaultview,
  };

  // This is LifeCycle method used to setup the default data for rendering
  componentDidMount() {
    // document.addEventListener('click', this.handleClickOutside);
    let {
      cycleLength,
      periodDuration,
      dayValue,
      monthValue,
      yearValue,
    } = this.props.currentMonthCycle;
    if (cycleLength === 0) cycleLength = 28;
    if (periodDuration === 0) periodDuration = 4;
    this.setState(
      (prevState, props) => {
        return {
          startDate: new Date(yearValue, monthValue, dayValue),
          cycleLengthValue: cycleLength,
          periodDuration: periodDuration,
        };
      },
      () => {
        this.props.sendLastPeriodData(
          this.state.dayValue,
          Number(this.state.monthValue),
          this.state.yearValue,
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          true,
          true
        );
      }
    );
  }

  // componentDidUpdate(nextProps) {

  // 	const { cycleLength, periodDuration } = this.props.currentMonthCycle
  // 	console.log(nextProps);
  // 	console.log(this.props.currentMonthCycle)
  // 	// let currentMonthData = this.props.calenderData[0];
  // 	if (nextProps.currentMonthCycle.cycleLength !== cycleLength ||
  // 		nextProps.currentMonthCycle.periodDuration !== periodDuration) {
  // 		this.setState({
  // 			cycleLengthValue: cycleLength,
  // 			periodDuration: periodDuration
  // 		})
  // 	}

  // }

  // handleClickOutside = (event) => {
  // 	if (event.target.className === 'avg-period-duration' ||
  // 		event.target.className === 'fa fa-minus' ||
  // 		event.target.className === 'fa fa-plus' || event.target.className === 'duration-count' || event.target.className === 'fa fa-clock' ||
  // 		event.target.className === 'plus-minus' || event.target.className === 'circle-minus' || event.target.className === 'circle-plus' ||
  // 		event.target.className === 'circle-minus-disabled' || event.target.className === 'circle-plus-disabled' ||
  // 		event.target.className === 'fa fa-plus fa-plus-disabled' || event.target.className === 'fa fa-minus fa-minus-disabled') {
  // 		this.setState({
  // 			showPlus: true,
  // 			showRangeSlider: false
  // 		})
  // 	} else if (event.target.className === 'period-cycle-range' ||
  // 		event.target.className === 'cycle-length' ||
  // 		event.target.className === 'input-range__slider' ||
  // 		event.target.className === 'range-wrap' ||
  // 		event.target.className === 'input-range__track input-range__track--active' ||
  // 		event.target.className === 'input-range__track input-range__track--background' ||
  // 		event.target.className === 'fa fa-clock range') {
  // 		this.setState({
  // 			showPlus: false,
  // 			showRangeSlider: true
  // 		})
  // 	}
  // 	else {
  // 		this.setState({
  // 			showPlus: false,
  // 			showRangeSlider: false
  // 		})
  // 	}

  // }

  increasePeriod = () => {
    if (this.state.periodDuration < 10) {
      this.setState(
        (prevState) => ({
          periodDuration: prevState.periodDuration + 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.isPeriodChange,
            this.state.isCycleChange
          );
        }
      );
    }
  };

  decreasePeriod = () => {
    if (this.state.periodDuration > 1) {
      this.setState(
        (prevState) => ({
          periodDuration: prevState.periodDuration - 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.isPeriodChange,
            this.state.isCycleChange
          );
        }
      );
    }
  };

  increaseCycle = () => {
    if (this.state.cycleLengthValue < 38) {
      this.setState(
        (prevState) => ({
          cycleLengthValue: prevState.cycleLengthValue + 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.isPeriodChange,
            this.state.isCycleChange
          );
        }
      );
    }
  };

  decreaseCycle = () => {
    if (this.state.cycleLengthValue > 21) {
      this.setState(
        (prevState) => ({
          cycleLengthValue: prevState.cycleLengthValue - 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.isPeriodChange,
            this.state.isCycleChange
          );
        }
      );
    }
  };

  handleCalendarOpen = () => {
    if (this.state.copen) {
      this.setState({ copen: false });
    } else {
      this.setState({ copen: true });
    }
  };

  changeDate = (date) => {
    this.setState(
      (prevState, props) => {
        return { startDate: date, copen: false };
      },
      () => {
        // 		dayValue: new Date().getDate(), // used for default selected value in dropdown
        // monthValue: new Date().getMonth(), // used for default selected value in dropdown
        // yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
        this.props.sendLastPeriodData(
          new Date(date).getDate(),
          new Date(date).getMonth(),
          new Date(date).getFullYear(),
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          this.state.isPeriodChange,
          this.state.isCycleChange
        );
      }
    );
    // date => {
    // this.setState({startDate: date, copen: false})
    // }
  };

  handleCalendarClose = (event) => {
    this.setState({ copen: false });
    /*event.preventDefault() */
  };

  render() {
    let { cycleLengthValue, isPeriodChange, isCycleChange } = this.state;
    let avgPeriodTextColor = isPeriodChange ? "#212529" : "#bfccdd";
    let cycleLengthTextColor = isCycleChange ? "#212529" : "#bfccdd";
    let currentmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth(),
      0
    ).getDate();
    let prevmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      0
    ).getDate();
    let mindate = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      1
    );
    let maxdate = prevmonthdays + currentmonthdays;
    return (
      <>
        <div className="calculator-field" data-test="last-period">
          <div className="field field-datepicker">
            <label>
              {this.state.dplabel}
              <a
                className="ttlink"
                alt={this.props.componentData.dateSelectionTooltip.value}
              >
                <i className="fa fa-question-circle"></i>
                <span>
                  {this.props.componentData.dateSelectionTooltip.value}
                </span>
              </a>
            </label>
            <DatePicker
              locale="enIN"
              //ref={this.calendarRef}
              minDate={
                new Date(
                  this.state.currentDate.getFullYear(),
                  this.state.currentDate.getMonth() - 1,
                  1
                )
              }
              //maxDate={addDays(new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1), maxdate)}
              maxDate={new Date()}
              dateFormat="dd MMMM, yyyy"
              showPopperArrow={false}
              selected={this.state.startDate}
              onChange={(date) => this.changeDate(date)}
              customInput={
                <Customdatepicker
                  imagepath={this.state.lastPeriodDateLogo}
                  placeholder="Select a date"
                />
              }
              showPreviousMonths={this.state.copen ? true : false}
              //showDisabledMonthNavigation
              // monthsShown={this.state.monthtoshown}
              //onInputClick={() => this.handleCalendarOpen()}
              //onClickOutside={() => this.handleCalendarClose(this)}
              //onClickOutside={() => {this.calendarRef.setOpen(false)}}>
              //open={this.state.copen}
              placeholderText="Select a date"
            ></DatePicker>
          </div>
        </div>

        <div className="duration-wrap">
          <label>
            {this.props.componentData.durationSelection1Label.value}
            <a
              className="ttlink"
              alt={this.props.componentData.durationSelection1Tooltip.value}
            >
              <i className="fa fa-question-circle"></i>
              <span>
                {this.props.componentData.durationSelection1Tooltip.value}
              </span>
            </a>
          </label>
          <div className="input-group">
            <input
              type="button"
              value="-"
              className="button-minus"
              data-field="quantity"
              onClick={this.decreasePeriod}
              disabled={this.state.periodDuration === 1}
            />
            <input
              type="text"
              id="avg-period-duration"
              readOnly
              placeholder="select Period"
              name="avg-period-duration"
              className={this.state.showPlus ? "avg-period-duration" : ""}
              onClick={this.togglePeriodDays}
              value={`${this.state.periodDuration}`}
              style={
                this.props.currentMonthCycle.periodDuration !== 0
                  ? { color: "#424C5F" }
                  : { color: avgPeriodTextColor }
              }
            />
            <input
              type="button"
              value="+"
              className="button-plus"
              data-field="quantity"
              onClick={this.increasePeriod}
              disabled={this.state.periodDuration === 10}
            />
          </div>
        </div>

        <div className="duration-wrap">
          <label>
            {this.props.componentData.durationSelection2Label.value}
            <a
              className="ttlink"
              alt={this.props.componentData.durationSelection2Tooltip.value}
            >
              <i className="fa fa-question-circle"></i>
              <span>
                {this.props.componentData.durationSelection2Tooltip.value}
              </span>
            </a>
          </label>
          <div className="input-group">
            <input
              type="button"
              value="-"
              className="button-minus"
              data-field="quantity"
              onClick={this.decreaseCycle}
              disabled={this.state.cycleLengthValue === 21}
            />
            <input
              type="text"
              id="period-cycle-length"
              readOnly
              className="period-cycle-range"
              value={`${cycleLengthValue}`}
              style={
                this.props.currentMonthCycle.cycleLength !== 0
                  ? { color: "#424C5F" }
                  : { color: cycleLengthTextColor }
              }
            />
            <input
              type="button"
              value="+"
              className="button-plus"
              data-field="quantity"
              onClick={this.increaseCycle}
              disabled={this.state.cycleLengthValue === 38}
            />
          </div>
        </div>
      </>
    );
  }
}

LastPeriod.propTypes = {
  componentData: PropTypes.shape({}).isRequired,
  sendLastPeriodData: PropTypes.func,
};

export default withTranslation()(LastPeriod);
